import React from 'react';

const InterviewListPage = React.lazy(() => import('@apps/Interview/pages/InterviewListPages'));
const InterviewEditPage = React.lazy(() => import('@apps/Interview/pages/InterviewEditPage'));
const InterviewRunPage = React.lazy(() => import('@apps/Interview/pages/InterviewRunPage'));
const InterviewMyResultPage = React.lazy(
  () => import('@apps/Interview/pages/InterviewMyResultPage'),
);
const InterviewResultsPage = React.lazy(() => import('@apps/Interview/pages/InterviewResultsPage'));

import { IPohodnikRouterItem } from '.';

const interviewRoutes: Array<IPohodnikRouterItem> = [
  {
    path: '/iv/:id/edit',
    component: ({
      match: {
        params: { id },
      },
    }) => <InterviewEditPage id_interview={id} />,
    protected: true,
    title: 'Редактирование опроса',
  },
  {
    path: '/iv/:id/results',
    component: ({
      match: {
        params: { id },
      },
    }) => <InterviewResultsPage id_interview={id} />,
    protected: true,
    title: 'Результаты опросов',
  },
  {
    path: '/iv/:id/result',
    component: ({
      match: {
        params: { id },
      },
    }) => <InterviewMyResultPage id_interview={id} />,
    protected: true,
    title: 'Результаты опроса',
  },
  {
    path: '/iv/:id/run',
    component: ({
      match: {
        params: { id },
      },
    }) => <InterviewRunPage id_interview={id} />,
    protected: true,
    title: 'Опрос',
  },
  {
    path: '/iv',
    component: () => <InterviewListPage />,
    protected: true,
    title: 'Список опросов',
  },
];

export default interviewRoutes;
